import { render, staticRenderFns } from "./ScalesOtherSettings.vue?vue&type=template&id=0665e378&scoped=true"
import script from "./ScalesOtherSettings.vue?vue&type=script&lang=js"
export * from "./ScalesOtherSettings.vue?vue&type=script&lang=js"
import style0 from "./ScalesOtherSettings.vue?vue&type=style&index=0&id=0665e378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665e378",
  null
  
)

export default component.exports